import React, { Component } from 'react';



class Login extends Component {


  render(){
    return (
    <div>
      <h3>Login here</h3>
      <a href="https://s0pagy2hj3.execute-api.us-east-1.amazonaws.com/prod/spotify-authorize/">Login Here</a>
    </div>
    );
  }
}

export default Login;


// WEBPACK FOOTER //
// ./src/components/LoginForm.js